<template>
    <v-card>
        <v-card-title>
            <v-row justify="space-between">
                <v-col cols="2"> Task Measurements </v-col>
                <v-spacer />
                <v-col cols="10" class="text-right">
                    <v-btn
                        class="mr-4"
                        :disabled="selectedItems.length === 0"
                        @click="downloadDataTemplate"
                        >Download Template</v-btn
                    >
                    <v-btn class="mr-4" @click="showImportUserMeasurementsDialog"
                        >Import Measurements</v-btn
                    >
                    <v-btn class="mr-4" v-if="showV1OTDataButton" @click="showV1OTData"
                        >Show V1 Data</v-btn
                    >
                    <v-icon @click="reloadData">$reload</v-icon>
                </v-col>
            </v-row>
        </v-card-title>
        <data-collection-task-data-table
            :cell-props="{ class: 'text-body-2' }"
            :show-edit-buttons="false"
            :show-measurements-buttons="true"
            :show-template-download="true"
            :show-filters-panel="true"
            :task-groups="taskSchedule.taskGroups"
            :readout-groups="taskSchedule.readoutGroups"
            :data-collection-tasks="taskSchedule.dataCollectionTasks"
            :experiment="experiment"
            :qc-statuses="taskSchedule.qcStatuses"
            :actual-user-dates="taskSchedule.actualUserCollectionDates"
            :protocol="protocol"
            @showUserMeasurements="showUserMeasurements"
            @showSummaryMeasurements="showSummaryMeasurements"
            @showQCDetailDialog="showQCDetailDialog"
            @openTaskStatusDialog="openTaskStatusDialog"
            @updateSelectedItems="updateSelected"
            v-model="selectedItems"
        />

        <v-dialog v-model="markTaskAsDoneDialogVisible" max-width="50%">
            <task-field-status-form
                v-if="selectedDataCollectionTask != null"
                :data-collection-task="selectedDataCollectionTask"
                :experiment="experiment"
                :task-schedule="taskSchedule"
                @cancelled="closeMarkTaskAsDoneDialog"
                @updatedTaskStatus="updatedTaskStatus"
            />
        </v-dialog>
    </v-card>
</template>
<script>
import { defineComponent } from "vue";

import DataCollectionTaskDataTable from "./DataCollectionTaskDataTable.vue";
import TaskFieldStatusForm from "./TaskFieldStatusForm.vue";

export default defineComponent({
    components: { DataCollectionTaskDataTable, TaskFieldStatusForm },
    props: {
        taskSchedule: {
            type: Object,
            required: true,
        },
        protocol: {
            type: Object, // AbstractSchemaConfig
            required: true,
        },
        experiment: {
            type: Object,
            required: true,
        },
        showV1OTDataButton: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        reloadData() {
            this.$emit("reloadData");
        },
        showUserMeasurements(dataCollectionTask) {
            this.$emit("showUserMeasurementsForTask", dataCollectionTask);
        },
        showSummaryMeasurements(dataCollectionTask) {
            this.$emit("showSummaryMeasurementsForTask", dataCollectionTask);
        },
        showQCDetailDialog(qcItem, dataCollectionTask) {
            this.$emit("showQCDetailDialog", qcItem, dataCollectionTask);
        },
        openTaskStatusDialog(dataCollectionTask) {
            this.selectedDataCollectionTask = dataCollectionTask;
            this.markTaskAsDoneDialogVisible = true;
        },
        showV1OTData() {
            this.$emit("showV1OTData");
        },
        downloadDataTemplate() {
            this.$emit("downloadDataTemplate", this.selectedItems);
        },
        showImportUserMeasurementsDialog() {
            this.$emit("showImportUserMeasurementsDialog");
        },
        updateSelected(selectedItems) {
            this.selectedItems = selectedItems;
        },
        closeMarkTaskAsDoneDialog() {
            this.markTaskAsDoneDialogVisible = false;
            this.selectedDataCollectionTask = null;
        },
        updatedTaskStatus() {
            this.markTaskAsDoneDialogVisible = false;
            this.reloadData();
        },
    },
    data() {
        return {
            selectedItems: [],
            markTaskAsDoneDialogVisible: false,
            selectedDataCollectionTask: null,
        };
    },
});
</script>
